import React from "react";
import WidgetSkeleton from "../widget/WidgetSkeleton";

type Props = {
  topCustomer: any | null;
  isLoadingTopCustomer: boolean;
};
const Section9 = ({ topCustomer, isLoadingTopCustomer }: Props) => {
  const data = Array.isArray(topCustomer?.data) ? topCustomer.data : [];
  const summary = topCustomer?.summary || {};

  const monthKeys: string[] = data[0]
    ? Object.keys(data[0].revenue)
    : ["Jan", "Feb", "Mar"];

  return (
    <div className="row mb-3">
      <div className="mb-2 col-12 col-sm-12 col-md-12 col-lg-10">
        <div className="card bg-white p-4" style={{ position: "relative" }}>
          {isLoadingTopCustomer && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "white",
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <WidgetSkeleton />
            </div>
          )}
          <div className="row mb-2">
            <div className="col-12">
              <div className="flex justify-between">
                <span className="text-black text-sm text-md-base">
                  PROFILE TOP 25 CUSTOMER (INVOICE UNPRODUCE)
                </span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="table-responsive">
                <table className="table table-sm" style={{ fontSize: "12px" }}>
                  <thead>
                    <tr>
                      <th
                        rowSpan={2}
                        style={{
                          backgroundColor: "#2a363c",
                          color: "white",
                          borderRadius: "10px 0 0 10px",
                          width: "4%",
                        }}
                      >
                        No.
                      </th>
                      <th
                        rowSpan={2}
                        style={{
                          backgroundColor: "#2a363c",
                          color: "white",
                          borderRadius: "0 10px 10px 0",
                          textAlign: "left",
                          paddingLeft: "10px",
                          width: "36%",
                        }}
                      >
                        Nama Pelanggan
                      </th>
                      <th
                        colSpan={monthKeys.length}
                        className="text-center"
                        style={{
                          backgroundColor: "#99b898",
                          color: "white",
                          borderRadius: "10px 10px 0px 0px",
                          borderBottom: "none",
                          width: "30%",
                        }}
                      >
                        Revenue (Rp.)
                      </th>
                      <th
                        colSpan={monthKeys.length}
                        className="text-center"
                        style={{
                          backgroundColor: "#b38957",
                          color: "white",
                          borderRadius: "10px 10px 0px 0px",
                          borderBottom: "none",
                          width: "30%",
                        }}
                      >
                        Invoice Unproduced (Rp.)
                      </th>
                    </tr>
                    <tr>
                      {monthKeys.map((month, i) => (
                        <th
                          key={`rev-head-${month}`}
                          className="text-center"
                          style={{
                            backgroundColor: "#99b898",
                            color: "white",
                            borderRadius:
                              i === 0
                                ? "0px 0px 0px 10px"
                                : i === monthKeys.length - 1
                                ? "0px 0px 10px 0px"
                                : "0px",
                            borderTop: "none",
                          }}
                        >
                          {month.toUpperCase()}
                        </th>
                      ))}
                      {monthKeys.map((month, i) => (
                        <th
                          key={`inv-head-${month}`}
                          className="text-center"
                          style={{
                            backgroundColor: "#b38957",
                            color: "white",
                            borderRadius:
                              i === 0
                                ? "0px 0px 0px 10px"
                                : i === monthKeys.length - 1
                                ? "0px 0px 10px 0px"
                                : "0px",
                            borderTop: "none",
                          }}
                        >
                          {month.toUpperCase()}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {isLoadingTopCustomer ? (
                      <tr>
                        <td colSpan={2 + monthKeys.length * 2}>Loading...</td>
                      </tr>
                    ) : data.length === 0 ? (
                      <tr>
                        <td colSpan={2 + monthKeys.length * 2}>No Data</td>
                      </tr>
                    ) : (
                      data.map((customer: any, idx: number) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td className="text-start">
                            {customer.customer_group_name_cco}
                          </td>
                          {monthKeys.map((month) => (
                            <td
                              key={`rev-${idx}-${month}`}
                              className="text-start"
                            >
                              Rp.{" "}
                              {Number(
                                customer.revenue[month] || 0
                              ).toLocaleString("id-ID")}
                            </td>
                          ))}
                          {monthKeys.map((month) => (
                            <td
                              key={`inv-${idx}-${month}`}
                              className="text-start"
                            >
                              Rp.{" "}
                              {Number(
                                customer.invoice_unproduce[month] || 0
                              ).toLocaleString("id-ID")}
                            </td>
                          ))}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-2 col-12 col-sm-12 col-md-12 col-lg-2">
        <div className="card bg-white p-4" style={{ height: 1010 }}>
          {isLoadingTopCustomer && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "white",
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <WidgetSkeleton />
            </div>
          )}
          <div style={{ marginBottom: 50 }}>
            <h6 className="text-black">SUMMARY</h6>
            <h6 className="text-black">PROFILE TOP 25</h6>
            <h6 className="text-black">CUSTOMER (INVOICE</h6>
            <h6 className="text-black">UNPRODUCE)</h6>
          </div>

          <div style={{ marginBottom: 50 }}>
            <h6 className="text-black mb-3">REVENUE</h6>
            {monthKeys.map((month, idx) => (
              <div key={`sum-inv-${month}`} className="mb-2">
                <div className="text-black">{month}</div>
                <div className="me-2">
                  Rp.{" "}
                  <span className="fw-bold fs-20 text-black">
                    {Number(summary[`revenue_${idx + 2}`] || 0).toLocaleString(
                      "id-ID"
                    )}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div style={{ marginBottom: 50 }}>
            <h6 className="text-black mb-3">INVOICE UNPRODUCED</h6>

            {monthKeys.map((month, idx) => {
              const current = summary[`invoice_unproduce_${idx + 2}`] || 0;
              const prev = summary[`invoice_unproduce_${idx + 1}`] || 0;

              const diff = prev > 0 ? current - prev : 0;
              const percent = prev > 0 ? (diff / prev) * 100 : 0;
              const isUp = diff > 0;

              return (
                <div key={`sum-inv-${month}`} className="mb-3">
                  <div className="text-black">
                    {<div className="text-black">{month}</div>}
                  </div>
                  <div className="me-2">
                    Rp.{" "}
                    <span className="fw-bold fs-20 text-black">
                      {Number(current).toLocaleString("id-ID")}
                    </span>
                  </div>
                  {prev >= 0 && (
                    <div className="d-flex align-items-center">
                      {isUp ? (
                        <span style={{ color: "green", fontSize: 20 }}>▲</span>
                      ) : (
                        <span style={{ color: "red", fontSize: 20 }}>▼</span>
                      )}
                      <div
                        className="ms-1 px-2 rounded text-white fw-bold"
                        style={{
                          backgroundColor: isUp ? "#28a745" : "#dc3545",
                        }}
                      >
                        {Math.abs(percent).toFixed(2)}%
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section9;
